/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
/* eslint-disable object-property-newline */
import Button from "@atlaskit/button";
import { DatePicker } from "@atlaskit/datetime-picker";
import { Field } from "@atlaskit/form";
import Select from "@atlaskit/select";
import dayjs from "dayjs";
import { ReactElement, useContext, useState } from "react";
import { InsuranceDropDown } from "../../components/InsuranceDropDown/InsuranceDropDown";
import { MessageContext } from "../../contexts/Message/MessageContext";
import API from "../../services/API";
import { SelectOpton } from "../../types/SelectedOption";
import "./Export.scss";
import { exportTypeOptions } from "./exportConstants";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface Props {}

export default function Export({}: Props): ReactElement {
    const [startDate, setStartDate] = useState<dayjs.Dayjs | null>(null);
    const [endDate, setEndDate] = useState<dayjs.Dayjs | null>(null);
    const [selectedOption, setSelectedOption] = useState<SelectOpton>(
        exportTypeOptions[0]
    );
    const messageContext = useContext(MessageContext);

    const [selectedInsurance, setSelectedInsurance] =
        useState<SelectOpton | null>(null);
    const dateTimePicker = (
        date: dayjs.Dayjs | null,
        onChange: (value: string) => void,
        label: string
    ) => (
        <Field name="preference" label={label} defaultValue="" isRequired>
            {({ fieldProps: {} }) => {
                const pickerDate = date
                    ? date.format("YYYY-MM-DD")
                    : dayjs().format("YYYY-MM-DD");
                return (
                    <>
                        <DatePicker
                            id={label}
                            locale="de"
                            value={pickerDate}
                            onChange={onChange}
                        />
                    </>
                );
            }}
        </Field>
    );
    const download = (filename: string, text: string) => {
        const element = document.createElement("a");
        element.setAttribute(
            "href",
            `data:text/plain;charset=utf-8,${encodeURIComponent(text)}`
        );
        element.setAttribute("download", filename);

        element.style.display = "none";
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    };
    const submit = () => {
        if (startDate && endDate && selectedOption && selectedInsurance) {
            API.HandleGetRequest<string>(
                `/export?startDate=${startDate.format(
                    "YYYY-MM-DD"
                )}&endDate=${endDate.format("YYYY-MM-DD")}&exportType=${selectedOption.value
                }&selectedInsurance=${selectedInsurance.label}`
            ).then((res) => {
                download(
                    `${dayjs().format("YYYY_MM_DD")}-${selectedOption.label
                    }.csv`,
                    res
                );
            });
        } else {
            messageContext.actions.showErrorMessage(
                "Bitte füllen Sie alle Felder korrekt aus!"
            );
        }
    };

    const areButtonsDisabled = !(
        startDate && endDate && startDate.isBefore(endDate)
    );
    return (
        <div className="form-wrapper">
            <div className="form-date-picker">
                <div className="cont">
                    {dateTimePicker(
                        startDate,
                        (date) => {
                            if (date) {
                                setStartDate(dayjs(date));
                            }
                        },
                        "Startdatum (incl.)"
                    )}
                </div>
                <div className="cont">
                    {dateTimePicker(
                        endDate,
                        (date) => {
                            if (date) {
                                setEndDate(dayjs(date));
                            }
                        },
                        "Enddatum (excl.)"
                    )}
                </div>
            </div>

            <div className="buttons-cont">
                <div className="buttons-select">
                    <Field name="exportType" label={"Export-Typ"}>
                        {() => (
                            <Select
                                onChange={(option) => {
                                    if (option) {
                                        setSelectedOption(option);
                                    }
                                }}
                                isMulti={false}
                                options={exportTypeOptions}
                                value={selectedOption}
                                closeMenuOnSelect={true}
                                popperProps={{
                                    placement: "bottom",
                                    strategy: "fixed",
                                }}
                                isLoading={false}
                            />
                        )}
                    </Field>

                    {selectedOption && (
                        <div
                            style={{ marginTop: 40 }}
                            className="buttons-select"
                        >
                            <InsuranceDropDown
                                setSelectedInsurance={setSelectedInsurance}
                                selectedInsurance={selectedInsurance}
                            />
                        </div>
                    )}
                </div>
                <div className="submit">
                    <Button
                        isDisabled={areButtonsDisabled}
                        appearance="primary"
                        onClick={() => submit()}
                    >
                        Exportieren
                    </Button>
                </div>
            </div>
        </div>
    );
}
